module.exports = __webpack_public_path__ + "legal-icon.svg?5887a9454c0ab5486947e323e8e16f64";